import { Card } from "react-bootstrap";
import i18n from "i18next";
import { PapyrusDocumentRepresentation } from "../../services/document/DocumentModels";

type UnsupportedViewerProps = {
    representation: PapyrusDocumentRepresentation;
};

export default function UnsupportedViewer({ representation }: UnsupportedViewerProps) {
    return (
        <Card>
            <Card.Body>
                <Card.Title>{i18n.t("viewer.unsupported")}</Card.Title>
                <Card.Text>
                    {i18n.t("viewer.unsupportedmessage")}
                </Card.Text>
                <dl>
                    <dt>{i18n.t("label.contenttype")}</dt>
                    <dd>{representation.contentType}</dd>
                    <dt>{i18n.t("label.attachmenturl")}</dt>
                    <dd>{representation.attachmentUrl ?? "-"}</dd>
                </dl>
            </Card.Body>
        </Card>
    );
}
